module.exports = __webpack_public_path__ + "img/banner-two-1.61ea2a0c.png";